export default __webpack_public_path__ + "images/Premier_League_logo.dd7ff5.png";